import { render, staticRenderFns } from "./testdelites.vue?vue&type=template&id=4462d73d&scoped=true"
import script from "./testdelites.vue?vue&type=script&lang=js"
export * from "./testdelites.vue?vue&type=script&lang=js"
import style0 from "./testdelites.vue?vue&type=style&index=0&id=4462d73d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462d73d",
  null
  
)

export default component.exports